<template>
	<span :class="`base-status-box base-status-box-${type}`">
		{{ message }}
	</span>
</template>

<script>
export default {
	name: 'base-status-box',
	props: {
		message: String,
		type: {
			type: String,
			default: 'success',
		},
	}
}
</script>

<style lang="scss" scoped>
.base-status-box {
	font-weight: 500;
	padding: 0.25em 0.6em 0.25em;
	border-radius: 0.3em;
	font-size: 75%;
	color: #fff;

	&-success {
		background: #46be8a;
	}

	&-warning {
		background: #f2a654;
	}

	&-danger {
		background: #f96868;
	}
}
</style>
